import { Box, Flex, Spacer, useDisclosure, Input } from "@chakra-ui/react";
import { Space, Table, TooltipProps } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useAdddishMaster } from "../../store/adddish/reducer";
import { RiDeleteBin6Line, RiEditLine, RiSearch2Line } from "react-icons/ri";
import AdddishMasterEditDrawer from "../drawer/AdddishMasterEditDrawer";
import DishesDeleteConfirmation from "../modals/DishesDeleteConfirmation";

interface Props {
  query: string;
}

const AdddishMasterTable: React.FC<Props> = ({ query }) => {
  const dispatch = useDispatch();
  const { masterAdddish, busy } = useAdddishMaster();
  const [targetData, setTargetData] = useState<any>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchQuery, setSearchQuery] = useState("");

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const deletes = (record: any) => {
    setTargetData(record);
    onDeleteOpen();
  };

  const update = (record: any) => {
    setTargetData(record);
    onOpen();
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const SingleImage = ({ image }: { image: string }) => (
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      <img
        src={image}
        alt="Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );

  const filteredData = useMemo(() => {
    const mappedData = masterAdddish.map((value: any) => ({
      _id: value._id,
      cuisine: value.cuisine || "-",
      name: value?.name || "-",
      dishimg: `${process.env.REACT_APP_IMAGE_BASE_URL}/${value.image.url}`,
      dishimgId: value.image._id,
    }));

    return mappedData.filter((dish: any) =>
      dish.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [masterAdddish, searchQuery]);

  const handleSearch = (e: any) => {
    setSearchQuery(e.target.value);
  };

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Dish Image",
      dataIndex: "dishimg",
      render: (image: string) => <SingleImage image={image} />,
    },
    {
      title: "Cuisine",
      dataIndex: "cuisine",
    },
    {
      title: "Dish Name",
      dataIndex: "name",
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      render: (_: any, record: any) => (
        <Space size="middle">
          <RiEditLine
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => update(record)}
          />
          <RiDeleteBin6Line
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => deletes(record)}
          />
        </Space>
      ),
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="498px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={handleSearch}
                value={searchQuery}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none", // Add this line to remove the blue outline
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none", // Add this line to ensure outline is removed in all browsers
                }}
              />
            </Box>

            <Spacer />

            <Box
              background="#E24441"
              fontSize={"sm"}
              color="#fff"
              w="fit-content"
              textAlign="center"
              p={3}
              cursor="pointer"
              borderRadius="8px"
              _hover={{ background: "#E24441" }}
              onClick={() => {
                onOpen();
                setTargetData(null);
              }}
            >
              + Add Dish
            </Box>
          </Flex>

          <Spacer></Spacer>

          <Table
            rowSelection={rowSelection}
            rowKey="key"
            columns={columns}
            dataSource={filteredData}
            scroll={{ x: "max-content" }}
            size="middle"
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            rowClassName={(record: any) => record.color}
            loading={busy && filteredData.length === 0 ? true : false}
          />
        </div>
      </div>

      {isOpen && (
        <AdddishMasterEditDrawer isOpen onClose={onClose} event={targetData} />
      )}

      {isDeleteOpen && targetData && (
        <DishesDeleteConfirmation
          isOpen
          onClose={onDeleteClose}
          event={targetData}
        />
      )}
    </>
  );
};

export default AdddishMasterTable;
